import correctSound from "../sound/correct-answer-notification.wav";
import incorrectSound from "../sound/incorrect-sound.wav";
import alertSound from "../sound/correct-positive-answer.wav";
import babySneezeSound from "../sound/mixkit-little-baby-sneeze-2214.wav";
import readyBeepSound from "../sound/mixkit-appliance-ready-beep-1076.wav";
import policeWhistle from "../sound/mixkit-police-short-whistle-615.wav";
import yahooSound from "../sound/sound-effect-YAHOO.wav";
import { user } from "localStorage";
import { GetRouteList } from "api/routes";
import { v4 as uuidv4 } from "uuid";
import imageCompression from "browser-image-compression";

export async function compressImage(file) {
  const options = {
    maxSizeMB: 0.5, // Target max size in MB (e.g. 500KB)
    maxWidthOrHeight: 1000, // Resize to max 1000px
    useWebWorker: true,
  };
  return await imageCompression(file, options);
}

export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function copyTextToClipboard(
  text = "Please provide text to copy to clipboard!"
) {
  navigator.clipboard.writeText(text);
  console.log(`Text copied!`);
}

export function selectAndFocus(elementId) {
  document.getElementById(elementId).select();
  document.getElementById(elementId).focus();
}

// Package.tracking maxlength — longer input is cut to the first 30 characters
// (same rule as backend/utils/tracking.js).
export const TRACKING_MAX_LENGTH = 30;

export function getScanText(text = "Pleasae provide text as string type") {
  let newText = text.toUpperCase().trim();
  
  if (newText.indexOf(" ") > 0) {
    newText = newText.slice(0, newText.indexOf(" "));
  }
  // console.log(newText)
  return newText.slice(0, TRACKING_MAX_LENGTH);
}

export function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export async function logout() {
  const user = localStorage.getItem("user");
  const defaultStation = localStorage.getItem("defaultStation");
  const customer = localStorage.getItem("customer");

  let isUser = user ? true : false;

  try {
    // Call secure logout API to clear httpOnly cookies and blacklist tokens
    const { secureLogout } = await import('../api/config');
    await secureLogout();
  } catch (error) {
    console.error('Logout API call failed:', error);
    // Continue with local cleanup even if API call fails
  }

  // Clear all local storage data
  localStorage.removeItem("token"); // Remove deprecated token storage
  
  if (isUser) {
    if (defaultStation) {
      localStorage.removeItem("defaultStation");
    }
    if (user) {
      localStorage.removeItem("user");
    }
    window.location = "/admin/login";
  } else {
    if (customer) {
      localStorage.removeItem("customer");
    }
    window.location = "/login";
  }
}

export function playCorrectSound() {
  var audio = new Audio(correctSound);
  audio.play();
}

export function playIncorrectSound() {
  var audio = new Audio(incorrectSound);
  audio.play();
}

export function playAlertSound() {
  var audio = new Audio(alertSound);
  audio.play();
}

export function playBabySneezeSound() {
  var audio = new Audio(babySneezeSound);
  audio.play();
}

export function playReadyBeebSound() {
  var audio = new Audio(readyBeepSound);
  audio.play();
}
export function playPoliceWhistleSound() {
  var audio = new Audio(policeWhistle);
  audio.play();
}
export function playYahooSound() {
  var audio = new Audio(yahooSound);
  audio.play();
}

export async function getValidRoutesByUser() {
  const _user = user();
  const stationIds = _user.stations.map((station) => station.id);
  const routes = await GetRouteList();
  console.log("🚀 ~ getValidRoutesByUser ~ routes:", routes);

  var filteredRoutes = [];
  if (routes && routes.success && routes.data) {
    filteredRoutes = routes.data.filter((route) =>
      route.navigator.some(
        (nav) =>
          stationIds.includes(nav.station) &&
          _user.stations.find((s) => s.id === nav.station)?.finalStation
      )
    );
  }

  console.log("🚀 ~ getValidRoutesByUser ~ filteredRoutes:", filteredRoutes);

  return filteredRoutes;
}

export function generateUniqueId(length = 10) {
  const uuid = uuidv4().replace(/-/g, ""); // Generate UUID and remove hyphens
  return uuid.substring(0, length); // Take the first 'length' characters
}

export function validatePhoneNumber(phoneNumber, countryCode = null) {
  const cleanedNumber = phoneNumber.replace(/\D/g, "");

  if (countryCode) {
    return validateByCountryCode(cleanedNumber, countryCode.toUpperCase());
  }

  return validateGlobally(cleanedNumber);
}

export function validateByCountryCode(cleanedNumber, countryCode) {
  const countryRules = [
    { code: "AD", regex: /^(376)?\d{6}$/, name: "Andorra", prefix: ["376"] },
    {
      code: "AE",
      regex: /^(971)?\d{9}$/,
      name: "United Arab Emirates",
      prefix: ["971"],
    },
    { code: "AF", regex: /^(93)?\d{9}$/, name: "Afghanistan", prefix: ["93"] },
    {
      code: "AG",
      regex: /^(1268)?\d{7}$/,
      name: "Antigua and Barbuda",
      prefix: ["1268"],
    },
    { code: "AI", regex: /^(1264)?\d{7}$/, name: "Anguilla", prefix: ["1264"] },
    { code: "AL", regex: /^(355)?\d{8,9}$/, name: "Albania", prefix: ["355"] },
    { code: "AM", regex: /^(374)?\d{8}$/, name: "Armenia", prefix: ["374"] },
    { code: "AO", regex: /^(244)?\d{9}$/, name: "Angola", prefix: ["244"] },
    { code: "AQ", regex: /^(672)?\d{6}$/, name: "Antarctica", prefix: ["672"] },
    {
      code: "AR",
      regex: /^(54)?\d{10,11}$/,
      name: "Argentina",
      prefix: ["54"],
    },
    {
      code: "AS",
      regex: /^(1684)?\d{7}$/,
      name: "American Samoa",
      prefix: ["1684"],
    },
    { code: "AT", regex: /^(43)?\d{1,13}$/, name: "Austria", prefix: ["43"] },
    { code: "AU", regex: /^(61)?(4\d{8})$/, name: "Australia", prefix: ["61"] },
    { code: "AW", regex: /^(297)?\d{7}$/, name: "Aruba", prefix: ["297"] },
    {
      code: "AX",
      regex: /^(358)?(18)\d{5}$/,
      name: "Åland Islands",
      prefix: ["358"],
    },
    { code: "AZ", regex: /^(994)?\d{9}$/, name: "Azerbaijan", prefix: ["994"] },
    {
      code: "BA",
      regex: /^(387)?\d{8,9}$/,
      name: "Bosnia and Herzegovina",
      prefix: ["387"],
    },
    { code: "BB", regex: /^(1246)?\d{7}$/, name: "Barbados", prefix: ["1246"] },
    {
      code: "BD",
      regex: /^(880)?\d{10}$/,
      name: "Bangladesh",
      prefix: ["880"],
    },
    { code: "BE", regex: /^(32)?\d{9}$/, name: "Belgium", prefix: ["32"] },
    {
      code: "BF",
      regex: /^(226)?\d{8}$/,
      name: "Burkina Faso",
      prefix: ["226"],
    },
    { code: "BG", regex: /^(359)?\d{9}$/, name: "Bulgaria", prefix: ["359"] },
    { code: "BH", regex: /^(973)?\d{8}$/, name: "Bahrain", prefix: ["973"] },
    { code: "BI", regex: /^(257)?\d{7,8}$/, name: "Burundi", prefix: ["257"] },
    { code: "BJ", regex: /^(229)?\d{8}$/, name: "Benin", prefix: ["229"] },
    {
      code: "BL",
      regex: /^(590)?\d{9}$/,
      name: "Saint Barthélemy",
      prefix: ["590"],
    },
    { code: "BM", regex: /^(1441)?\d{7}$/, name: "Bermuda", prefix: ["1441"] },
    {
      code: "BN",
      regex: /^(673)?\d{7}$/,
      name: "Brunei Darussalam",
      prefix: ["673"],
    },
    {
      code: "BO",
      regex: /^(591)?\d{7,8}$/,

      name: "Bolivia Plurinational State of",
      prefix: ["591"],
    },
    {
      code: "BQ",
      regex: /^(599)?\d{7}$/,
      name: "Bonaire Sint Eustatius and Saba",
      prefix: ["599"],
    },
    { code: "BR", regex: /^(55)?\d{10,11}$/, name: "Brazil", prefix: ["55"] },
    { code: "BS", regex: /^(1242)?\d{7}$/, name: "Bahamas", prefix: ["1242"] },
    { code: "BT", regex: /^(975)?\d{7,8}$/, name: "Bhutan", prefix: ["975"] },
    {
      code: "BV",
      regex: /^(47)?\d{8}$/,
      name: "Bouvet Island",
      prefix: ["47"],
    },
    { code: "BW", regex: /^(267)?\d{7,8}$/, name: "Botswana", prefix: ["267"] },
    { code: "BY", regex: /^(375)?\d{9}$/, name: "Belarus", prefix: ["375"] },
    { code: "BZ", regex: /^(501)?\d{7}$/, name: "Belize", prefix: ["501"] },
    {
      code: "CA",
      regex: /^(1)?[2-9]\d{2}[2-9]\d{2}\d{4}$/,
      name: "Canada",
      prefix: ["1"],
    },
    {
      code: "CC",
      regex: /^(61)?(89162)\d{4}$/,
      name: "Cocos (Keeling) Islands",
      prefix: ["61"],
    },
    {
      code: "CD",
      regex: /^(243)?\d{9}$/,
      name: "Congo the Democratic Republic of the",
      prefix: ["243"],
    },
    {
      code: "CF",
      regex: /^(236)?\d{8}$/,
      name: "Central African Republic",
      prefix: ["236"],
    },
    { code: "CG", regex: /^(242)?\d{9}$/, name: "Congo", prefix: ["242"] },
    { code: "CH", regex: /^(41)?\d{9}$/, name: "Switzerland", prefix: ["41"] },
    {
      code: "CI",
      regex: /^(225)?\d{8}$/,
      name: "Côte d'Ivoire",
      prefix: ["225"],
    },
    {
      code: "CK",
      regex: /^(682)?\d{5}$/,
      name: "Cook Islands",
      prefix: ["682"],
    },
    { code: "CL", regex: /^(56)?\d{9}$/, name: "Chile", prefix: ["56"] },
    { code: "CM", regex: /^(237)?\d{8}$/, name: "Cameroon", prefix: ["237"] },
    {
      code: "CN",
      regex: /^(86)?(1[3-9]\d{9})$/,
      name: "China",
      prefix: ["86"],
    },
    { code: "CO", regex: /^(57)?\d{10}$/, name: "Colombia", prefix: ["57"] },
    { code: "CR", regex: /^(506)?\d{8}$/, name: "Costa Rica", prefix: ["506"] },
    { code: "CU", regex: /^(53)?\d{8}$/, name: "Cuba", prefix: ["53"] },
    {
      code: "CV",
      regex: /^(238)?\d{7,8}$/,
      name: "Cabo Verde",
      prefix: ["238"],
    },
    { code: "CW", regex: /^(599)?\d{7}$/, name: "Curaçao", prefix: ["599"] },
    {
      code: "CX",
      regex: /^(61)?(89164)\d{4}$/,
      name: "Christmas Island",
      prefix: ["61"],
    },
    { code: "CY", regex: /^(357)?\d{8}$/, name: "Cyprus", prefix: ["357"] },
    { code: "CZ", regex: /^(420)?\d{9}$/, name: "Czechia", prefix: ["420"] },
    {
      code: "DE",
      regex: /^(49)?(1[5-7]\d{8}"1[7-9]\d{8}"16\d{9})$/,
      name: "Germany",
      prefix: ["49"],
    },
    { code: "DJ", regex: /^(253)?\d{8}$/, name: "Djibouti", prefix: ["253"] },
    { code: "DK", regex: /^(45)?\d{8}$/, name: "Denmark", prefix: ["45"] },
    { code: "DM", regex: /^(1767)?\d{7}$/, name: "Dominica", prefix: ["1767"] },
    {
      code: "DO",
      regex: /^(1809"1829"1849)?\d{7}$/,
      name: "Dominican Republic",
      prefix: [1809, 1829, 1849],
    },
    { code: "DZ", regex: /^(213)?\d{9}$/, name: "Algeria", prefix: ["213"] },
    { code: "EC", regex: /^(593)?\d{9}$/, name: "Ecuador", prefix: ["593"] },
    { code: "EE", regex: /^(372)?\d{7,8}$/, name: "Estonia", prefix: ["372"] },
    { code: "EG", regex: /^(20)?\d{10}$/, name: "Egypt", prefix: ["20"] },
    {
      code: "EH",
      regex: /^(212)?\d{9}$/,
      name: "Western Sahara",
      prefix: ["212"],
    },
    { code: "ER", regex: /^(291)?\d{7}$/, name: "Eritrea", prefix: ["291"] },
    { code: "ES", regex: /^(34)?\d{9}$/, name: "Spain", prefix: ["34"] },
    { code: "ET", regex: /^(251)?\d{9}$/, name: "Ethiopia", prefix: ["251"] },
    { code: "FI", regex: /^(358)?\d{9}$/, name: "Finland", prefix: ["358"] },
    { code: "FJ", regex: /^(679)?\d{7}$/, name: "Fiji", prefix: ["679"] },
    {
      code: "FK",
      regex: /^(500)?\d{5}$/,
      name: "Falkland Islands (Malvinas)",
      prefix: ["500"],
    },
    {
      code: "FM",
      regex: /^(691)?\d{7}$/,

      name: "Micronesia Federated States of",
      prefix: ["691"],
    },
    {
      code: "FO",
      regex: /^(298)?\d{6}$/,
      name: "Faroe Islands",
      prefix: ["298"],
    },
    { code: "FR", regex: /^(33)?[67]\d{8}$/, name: "France", prefix: ["33"] },
    { code: "GA", regex: /^(241)?\d{7}$/, name: "Gabon", prefix: ["241"] },
    {
      code: "GB",
      regex: /^(44)?(7\d{9})$/,
      name: "United Kingdom",
      prefix: ["44"],
    },
    { code: "GD", regex: /^(1473)?\d{7}$/, name: "Grenada", prefix: ["1473"] },
    { code: "GE", regex: /^(995)?\d{9}$/, name: "Georgia", prefix: ["995"] },
    {
      code: "GF",
      regex: /^(594)?\d{9}$/,
      name: "French Guiana",
      prefix: ["594"],
    },
    {
      code: "GG",
      regex: /^(44)?(1481"7781"7839"7911)\d{6}$/,
      name: "Guernsey",
      prefix: ["44"],
    },
    { code: "GH", regex: /^(233)?\d{9}$/, name: "Ghana", prefix: ["233"] },
    { code: "GI", regex: /^(350)?\d{7}$/, name: "Gibraltar", prefix: ["350"] },
    { code: "GL", regex: /^(299)?\d{6}$/, name: "Greenland", prefix: ["299"] },
    { code: "GM", regex: /^(220)?\d{7}$/, name: "Gambia", prefix: ["220"] },
    { code: "GN", regex: /^(224)?\d{8}$/, name: "Guinea", prefix: ["224"] },
    { code: "GP", regex: /^(590)?\d{9}$/, name: "Guadeloupe", prefix: ["590"] },
    {
      code: "GQ",
      regex: /^(240)?\d{9}$/,
      name: "Equatorial Guinea",
      prefix: ["240"],
    },
    { code: "GR", regex: /^(30)?\d{10}$/, name: "Greece", prefix: ["30"] },
    {
      code: "GS",
      regex: /^(500)?\d{5}$/,
      name: "South Georgia and the South Sandwich Islands",
      prefix: ["500"],
    },
    { code: "GT", regex: /^(502)?\d{8}$/, name: "Guatemala", prefix: ["502"] },
    { code: "GU", regex: /^(1671)?\d{7}$/, name: "Guam", prefix: ["1671"] },
    {
      code: "GW",
      regex: /^(245)?\d{7}$/,
      name: "Guinea-Bissau",
      prefix: ["245"],
    },
    { code: "GY", regex: /^(592)?\d{7}$/, name: "Guyana", prefix: ["592"] },
    { code: "HK", regex: /^(852)?\d{8}$/, name: "Hong Kong", prefix: ["852"] },
    {
      code: "HM",
      regex: /^(672)?\d{6}$/,
      name: "Heard Island and McDonald Islands",
      prefix: ["672"],
    },
    { code: "HN", regex: /^(504)?\d{8}$/, name: "Honduras", prefix: ["504"] },
    { code: "HR", regex: /^(385)?\d{9}$/, name: "Croatia", prefix: ["385"] },
    { code: "HT", regex: /^(509)?\d{8}$/, name: "Haiti", prefix: ["509"] },
    { code: "HU", regex: /^(36)?\d{9}$/, name: "Hungary", prefix: ["36"] },
    { code: "ID", regex: /^(62)?\d{9,12}$/, name: "Indonesia", prefix: ["62"] },
    { code: "IE", regex: /^(353)?\d{7,9}$/, name: "Ireland", prefix: ["353"] },
    { code: "IL", regex: /^(972)?\d{8,9}$/, name: "Israel", prefix: ["972"] },
    {
      code: "IM",
      regex: /^(44)?(1624"74576"7524"7624"7924)\d{6}$/,
      name: "Isle of Man",
      prefix: ["44"],
    },
    { code: "IN", regex: /^(91)?[6-9]\d{9}$/, name: "India", prefix: ["91"] },
    {
      code: "IO",
      regex: /^(246)?\d{7}$/,
      name: "British Indian Ocean Territory",
      prefix: ["246"],
    },
    { code: "IQ", regex: /^(964)?\d{10}$/, name: "Iraq", prefix: ["964"] },
    {
      code: "IR",
      regex: /^(98)?\d{10}$/,
      name: " Iran - Islamic Republic of",
      prefix: ["98"],
    },
    { code: "IS", regex: /^(354)?\d{7}$/, name: "Iceland", prefix: ["354"] },
    { code: "IT", regex: /^(39)?\d{9,10}$/, name: "Italy", prefix: ["39"] },
    {
      code: "JE",
      regex: /^(44)?(1534"7700"7797"7829"7937)\d{6}$/,
      name: "Jersey",
      prefix: ["44"],
    },
    { code: "JM", regex: /^(1876)?\d{7}$/, name: "Jamaica", prefix: ["1876"] },
    { code: "JO", regex: /^(962)?\d{9}$/, name: "Jordan", prefix: ["962"] },
    { code: "JP", regex: /^(81)?[789]0\d{8}$/, name: "Japan", prefix: ["81"] },
    { code: "KE", regex: /^(254)?\d{9}$/, name: "Kenya", prefix: ["254"] },
    { code: "KG", regex: /^(996)?\d{9}$/, name: "Kyrgyzstan", prefix: ["996"] },
    { code: "KH", regex: /^(855)?\d{8,9}$/, name: "Cambodia", prefix: ["855"] },
    { code: "KI", regex: /^(686)?\d{5}$/, name: "Kiribati", prefix: ["686"] },
    { code: "KM", regex: /^(269)?\d{7}$/, name: "Comoros", prefix: ["269"] },
    {
      code: "KN",
      regex: /^(1869)?\d{7}$/,
      name: "Saint Kitts and Nevis",
      prefix: ["1869"],
    },
    {
      code: "KP",
      regex: /^(850)?\d{9}$/,
      name: "Korea Democratic People's Republic of",
      prefix: ["850"],
    },
    {
      code: "KR",
      regex: /^(82)?(10)\d{8}$/,
      name: "Korea Republic of",
      prefix: ["82"],
    },
    { code: "KW", regex: /^(965)?\d{8}$/, name: "Kuwait", prefix: ["965"] },
    {
      code: "KY",
      regex: /^(1345)?\d{7}$/,
      name: "Cayman Islands",
      prefix: ["1345"],
    },
    { code: "KZ", regex: /^(7)?[67]\d{9}$/, name: "Kazakhstan", prefix: ["7"] },
    {
      code: "LA",
      regex: /^(856)?\d{9}$/,
      name: "Lao People's Democratic Republic",
      prefix: ["856"],
    },
    { code: "LB", regex: /^(961)?\d{7,8}$/, name: "Lebanon", prefix: ["961"] },
    {
      code: "LC",
      regex: /^(1758)?\d{7}$/,
      name: "Saint Lucia",
      prefix: ["1758"],
    },
    {
      code: "LI",
      regex: /^(423)?\d{7}$/,
      name: "Liechtenstein",
      prefix: ["423"],
    },
    { code: "LK", regex: /^(94)?\d{9}$/, name: "Sri Lanka", prefix: ["94"] },
    { code: "LR", regex: /^(231)?\d{7,8}$/, name: "Liberia", prefix: ["231"] },
    { code: "LS", regex: /^(266)?\d{8}$/, name: "Lesotho", prefix: ["266"] },
    { code: "LT", regex: /^(370)?\d{8}$/, name: "Lithuania", prefix: ["370"] },
    {
      code: "LU",
      regex: /^(352)?\d{6,9}$/,
      name: "Luxembourg",
      prefix: ["352"],
    },
    { code: "LV", regex: /^(371)?\d{8}$/, name: "Latvia", prefix: ["371"] },
    { code: "LY", regex: /^(218)?\d{9}$/, name: "Libya", prefix: ["218"] },
    { code: "MA", regex: /^(212)?\d{9}$/, name: "Morocco", prefix: ["212"] },
    { code: "MC", regex: /^(377)?\d{8,9}$/, name: "Monaco", prefix: ["377"] },
    { code: "MD", regex: /^(373)?\d{8}$/, name: "Moldova", prefix: ["373"] },
    { code: "ME", regex: /^(382)?\d{8}$/, name: "Montenegro", prefix: ["382"] },
    {
      code: "MF",
      regex: /^(590)?\d{9}$/,
      name: "Saint Martin (French part)",
      prefix: ["590"],
    },
    { code: "MG", regex: /^(261)?\d{9}$/, name: "Madagascar", prefix: ["261"] },
    {
      code: "MH",
      regex: /^(692)?\d{7}$/,
      name: "Marshall Islands",
      prefix: ["692"],
    },
    {
      code: "MK",
      regex: /^(389)?\d{8}$/,
      name: "North Macedonia",
      prefix: ["389"],
    },
    { code: "ML", regex: /^(223)?\d{8}$/, name: "Mali", prefix: ["223"] },
    { code: "MM", regex: /^(95)?\d{7,9}$/, name: "Myanmar", prefix: ["95"] },
    { code: "MN", regex: /^(976)?\d{8}$/, name: "Mongolia", prefix: ["976"] },
    { code: "MO", regex: /^(853)?\d{8}$/, name: "Macao", prefix: ["853"] },
    {
      code: "MP",
      regex: /^(1670)?\d{7}$/,
      name: "Northern Mariana Islands",
      prefix: ["1670"],
    },
    { code: "MQ", regex: /^(596)?\d{9}$/, name: "Martinique", prefix: ["596"] },
    { code: "MR", regex: /^(222)?\d{8}$/, name: "Mauritania", prefix: ["222"] },
    {
      code: "MS",
      regex: /^(1664)?\d{7}$/,
      name: "Montserrat",
      prefix: ["1664"],
    },
    { code: "MT", regex: /^(356)?\d{8}$/, name: "Malta", prefix: ["356"] },
    {
      code: "MU",
      regex: /^(230)?\d{7,8}$/,
      name: "Mauritius",
      prefix: ["230"],
    },
    { code: "MV", regex: /^(960)?\d{7}$/, name: "Maldives", prefix: ["960"] },
    { code: "MW", regex: /^(265)?\d{8,9}$/, name: "Malawi", prefix: ["265"] },
    { code: "MX", regex: /^(52)?\d{10}$/, name: "Mexico", prefix: ["52"] },
    { code: "MY", regex: /^(60)?\d{9,10}$/, name: "Malaysia", prefix: ["60"] },
    { code: "MZ", regex: /^(258)?\d{8}$/, name: "Mozambique", prefix: ["258"] },
    { code: "NA", regex: /^(264)?\d{9}$/, name: "Namibia", prefix: ["264"] },
    {
      code: "NC",
      regex: /^(687)?\d{6}$/,
      name: "New Caledonia",
      prefix: ["687"],
    },
    { code: "NE", regex: /^(227)?\d{8}$/, name: "Niger", prefix: ["227"] },
    {
      code: "NF",
      regex: /^(672)?\d{5}$/,
      name: "Norfolk Island",
      prefix: ["672"],
    },
    {
      code: "NG",
      regex: /^(234)?\d{10,11}$/,
      name: "Nigeria",
      prefix: ["234"],
    },
    { code: "NI", regex: /^(505)?\d{8}$/, name: "Nicaragua", prefix: ["505"] },
    {
      code: "NL",
      regex: /^(31)?(6)\d{8}$/,
      name: "Netherlands",
      prefix: ["31"],
    },
    { code: "NO", regex: /^(47)?\d{8}$/, name: "Norway", prefix: ["47"] },
    { code: "NP", regex: /^(977)?\d{10}$/, name: "Nepal", prefix: ["977"] },
    { code: "NR", regex: /^(674)?\d{7}$/, name: "Nauru", prefix: ["674"] },
    { code: "NU", regex: /^(683)?\d{4}$/, name: "Niue", prefix: ["683"] },
    {
      code: "NZ",
      regex: /^(64)?\d{7,10}$/,
      name: "New Zealand",
      prefix: ["64"],
    },
    { code: "OM", regex: /^(968)?\d{8}$/, name: "Oman", prefix: ["968"] },
    { code: "PA", regex: /^(507)?\d{8}$/, name: "Panama", prefix: ["507"] },
    { code: "PE", regex: /^(51)?\d{9}$/, name: "Peru", prefix: ["51"] },
    {
      code: "PF",
      regex: /^(689)?\d{8}$/,
      name: "French Polynesia",
      prefix: ["689"],
    },
    {
      code: "PG",
      regex: /^(675)?\d{7,8}$/,
      name: "Papua New Guinea",
      prefix: ["675"],
    },
    {
      code: "PH",
      regex: /^(63)?\d{10,11}$/,
      name: "Philippines",
      prefix: ["63"],
    },
    { code: "PK", regex: /^(92)?\d{10}$/, name: "Pakistan", prefix: ["92"] },
    { code: "PL", regex: /^(48)?\d{9}$/, name: "Poland", prefix: ["48"] },
    {
      code: "PM",
      regex: /^(508)?\d{6}$/,
      name: "Saint Pierre and Miquelon",
      prefix: ["508"],
    },
    { code: "PN", regex: /^(64)?\d{8}$/, name: "Pitcairn", prefix: ["64"] },
    {
      code: "PR",
      regex: /^(1787"1939)?\d{7}$/,
      name: "Puerto Rico",
      prefix: ["1787", "1939"],
    },
    { code: "PS", regex: /^(970)?\d{9}$/, name: "Palestin", prefix: ["970"] },
    { code: "PT", regex: /^(351)?\d{9}$/, name: "Portugal", prefix: ["351"] },
    { code: "PW", regex: /^(680)?\d{7}$/, name: "Palau", prefix: ["680"] },
    { code: "PY", regex: /^(595)?\d{9}$/, name: "Paraguay", prefix: ["595"] },
    { code: "QA", regex: /^(974)?\d{8}$/, name: "Qatar", prefix: ["974"] },
    { code: "RE", regex: /^(262)?\d{9}$/, name: "Réunion", prefix: ["262"] },
    { code: "RO", regex: /^(40)?\d{9}$/, name: "Romania", prefix: ["40"] },
    { code: "RS", regex: /^(381)?\d{9}$/, name: "Serbia", prefix: ["381"] },
    {
      code: "RU",
      regex: /^(7"8)?\d{10}$/,
      name: "Russian Federation",
      prefix: ["7", "8"],
    },
    { code: "RW", regex: /^(250)?\d{7,9}$/, name: "Rwanda", prefix: ["250"] },
    {
      code: "SA",
      regex: /^(966)?\d{9}$/,
      name: "Saudi Arabia",
      prefix: ["966"],
    },
    {
      code: "SB",
      regex: /^(677)?\d{5}$/,
      name: "Solomon Islands",
      prefix: ["677"],
    },
    { code: "SC", regex: /^(248)?\d{7}$/, name: "Seychelles", prefix: ["248"] },
    { code: "SD", regex: /^(249)?\d{7,8}$/, name: "Sudan", prefix: ["249"] },
    { code: "SE", regex: /^(46)?\d{9}$/, name: "Sweden", prefix: ["46"] },
    { code: "SG", regex: /^(65)?\d{8}$/, name: "Singapore", prefix: ["65"] },
    {
      code: "SH",
      regex: /^(290)?\d{4,5}$/,
      name: "Saint Helena",
      prefix: ["290"],
    },
    { code: "SI", regex: /^(386)?\d{8}$/, name: "Slovenia", prefix: ["386"] },
    {
      code: "SJ",
      regex: /^(47)?\d{8}$/,
      name: "Svalbard and Jan Mayen",
      prefix: ["47"],
    },
    { code: "SK", regex: /^(421)?\d{9}$/, name: "Slovakia", prefix: ["421"] },
    {
      code: "SL",
      regex: /^(232)?\d{7,8}$/,
      name: "Sierra Leone",
      prefix: ["232"],
    },
    {
      code: "SM",
      regex: /^(378)?\d{6,10}$/,
      name: "San Marino",
      prefix: ["378"],
    },
    { code: "SN", regex: /^(221)?\d{9}$/, name: "Senegal", prefix: ["221"] },
    { code: "SO", regex: /^(252)?\d{8,9}$/, name: "Somalia", prefix: ["252"] },
    { code: "SR", regex: /^(597)?\d{7}$/, name: "Suriname", prefix: ["597"] },
    {
      code: "SS",
      regex: /^(211)?\d{7}$/,
      name: "South Sudan",
      prefix: ["211"],
    },
    {
      code: "ST",
      regex: /^(239)?\d{7}$/,
      name: "Sao Tome and Principe",
      prefix: ["239"],
    },
    {
      code: "SV",
      regex: /^(503)?\d{8}$/,
      name: "El Salvador",
      prefix: ["503"],
    },
    {
      code: "SX",
      regex: /^(1721)?\d{7}$/,
      name: "Sint Maarten (Dutch part)",
      prefix: ["1721"],
    },
    {
      code: "SY",
      regex: /^(963)?\d{9}$/,
      name: "Syrian Arab Republic",
      prefix: ["963"],
    },
    { code: "SZ", regex: /^(268)?\d{7}$/, name: "Eswatini", prefix: ["268"] },
    {
      code: "TC",
      regex: /^(1649)?\d{7}$/,
      name: "Turks and Caicos Islands",
      prefix: ["1649"],
    },
    { code: "TD", regex: /^(235)?\d{8}$/, name: "Chad", prefix: ["235"] },
    {
      code: "TF",
      regex: /^(262)?\d{9}$/,
      name: "French Southern Territories",
      prefix: ["262"],
    },
    { code: "TG", regex: /^(228)?\d{8}$/, name: "Togo", prefix: ["228"] },
    { code: "TH", regex: /^(66)?\d{9}$/, name: "Thailand", prefix: ["66"] },
    { code: "TJ", regex: /^(992)?\d{9}$/, name: "Tajikistan", prefix: ["992"] },
    { code: "TK", regex: /^(690)?\d{4}$/, name: "Tokelau", prefix: ["690"] },
    {
      code: "TL",
      regex: /^(670)?\d{7}$/,
      name: "Timor-Leste",
      prefix: ["670"],
    },
    {
      code: "TM",
      regex: /^(993)?\d{8}$/,
      name: "Turkmenistan",
      prefix: ["993"],
    },
    { code: "TN", regex: /^(216)?\d{8}$/, name: "Tunisia", prefix: ["216"] },
    { code: "TO", regex: /^(676)?\d{5,7}$/, name: "Tonga", prefix: ["676"] },
    { code: "TR", regex: /^(90)?\d{10}$/, name: "Turkey", prefix: ["90"] },
    {
      code: "TT",
      regex: /^(1868)?\d{7}$/,
      name: "Trinidad and Tobago",
      prefix: ["1868"],
    },
    { code: "TV", regex: /^(688)?\d{5}$/, name: "Tuvalu", prefix: ["688"] },
    { code: "TW", regex: /^(886)?\d{9}$/, name: "Taiwan", prefix: ["886"] },
    { code: "TZ", regex: /^(255)?\d{9}$/, name: "Tanzania", prefix: ["255"] },
    { code: "UA", regex: /^(380)?\d{9}$/, name: "Ukraine", prefix: ["380"] },
    { code: "UG", regex: /^(256)?\d{9}$/, name: "Uganda", prefix: ["256"] },
    {
      code: "UM",
      regex: /^(1)?\d{10}$/,
      name: "United States Minor Outlying Islands",
      prefix: ["1"],
    },
    {
      code: "US",
      regex: /^(1)?[2-9]\d{2}[2-9]\d{2}\d{4}$/,
      name: "United States",
      prefix: ["1"],
    },
    { code: "UY", regex: /^(598)?\d{8,9}$/, name: "Uruguay", prefix: ["598"] },
    { code: "UZ", regex: /^(998)?\d{9}$/, name: "Uzbekistan", prefix: ["998"] },
    {
      code: "VA",
      regex: /^(379)?\d{6,10}$/,
      name: "Vatican City State",
      prefix: ["379"],
    },
    {
      code: "VC",
      regex: /^(1784)?\d{7}$/,
      name: "Saint Vincent and the Grenadines",
      prefix: ["1784"],
    },
    { code: "VE", regex: /^(58)?\d{10}$/, name: "Venezuela", prefix: ["58"] },
    {
      code: "VG",
      regex: /^(1284)?\d{7}$/,
      name: "Virgin Islands British",
      prefix: ["1284"],
    },
    {
      code: "VI",
      regex: /^(1340)?\d{7}$/,
      name: "Virgin Islands U.S.",
      prefix: ["1340"],
    },
    { code: "VN", regex: /^(84)?\d{8,9}$/, name: "Viet Nam", prefix: ["84"] },
    { code: "VU", regex: /^(678)?\d{7}$/, name: "Vanuatu", prefix: ["678"] },
    {
      code: "WF",
      regex: /^(681)?\d{6}$/,
      name: "Wallis and Futuna",
      prefix: ["681"],
    },
    { code: "WS", regex: /^(685)?\d{5,7}$/, name: "Samoa", prefix: ["685"] },
    { code: "YE", regex: /^(967)?\d{9}$/, name: "Yemen", prefix: ["967"] },
    { code: "YT", regex: /^(262)?\d{9}$/, name: "Mayotte", prefix: ["262"] },
    { code: "ZA", regex: /^(27)?\d{9}$/, name: "South Africa", prefix: ["27"] },
    { code: "ZM", regex: /^(260)?\d{9}$/, name: "Zambia", prefix: ["260"] },
    { code: "ZW", regex: /^(263)?\d{9}$/, name: "Zimbabwe", prefix: ["263"] },
  ];
  // use find to find the object with the right country code.
  const countryRule = countryRules.find((rule) => rule.code === countryCode);

  if (countryRule) {
    return countryRule.regex.test(cleanedNumber);
  }
  return false;
}

function validateGlobally(cleanedNumber) {
  return cleanedNumber.length >= 7 && cleanedNumber.length <= 15;
}

export function countryRules() {
  const countryRules = [
    { code: "AD", regex: /^(376)?\d{6}$/, name: "Andorra", prefix: ["376"] },
    {
      code: "AE",
      regex: /^(971)?\d{9}$/,
      name: "United Arab Emirates",
      prefix: ["971"],
    },
    { code: "AF", regex: /^(93)?\d{9}$/, name: "Afghanistan", prefix: ["93"] },
    {
      code: "AG",
      regex: /^(1268)?\d{7}$/,
      name: "Antigua and Barbuda",
      prefix: ["1268"],
    },
    { code: "AI", regex: /^(1264)?\d{7}$/, name: "Anguilla", prefix: ["1264"] },
    { code: "AL", regex: /^(355)?\d{8,9}$/, name: "Albania", prefix: ["355"] },
    { code: "AM", regex: /^(374)?\d{8}$/, name: "Armenia", prefix: ["374"] },
    { code: "AO", regex: /^(244)?\d{9}$/, name: "Angola", prefix: ["244"] },
    { code: "AQ", regex: /^(672)?\d{6}$/, name: "Antarctica", prefix: ["672"] },
    {
      code: "AR",
      regex: /^(54)?\d{10,11}$/,
      name: "Argentina",
      prefix: ["54"],
    },
    {
      code: "AS",
      regex: /^(1684)?\d{7}$/,
      name: "American Samoa",
      prefix: ["1684"],
    },
    { code: "AT", regex: /^(43)?\d{1,13}$/, name: "Austria", prefix: ["43"] },
    { code: "AU", regex: /^(61)?(4\d{8})$/, name: "Australia", prefix: ["61"] },
    { code: "AW", regex: /^(297)?\d{7}$/, name: "Aruba", prefix: ["297"] },
    {
      code: "AX",
      regex: /^(358)?(18)\d{5}$/,
      name: "Åland Islands",
      prefix: ["358"],
    },
    { code: "AZ", regex: /^(994)?\d{9}$/, name: "Azerbaijan", prefix: ["994"] },
    {
      code: "BA",
      regex: /^(387)?\d{8,9}$/,
      name: "Bosnia and Herzegovina",
      prefix: ["387"],
    },
    { code: "BB", regex: /^(1246)?\d{7}$/, name: "Barbados", prefix: ["1246"] },
    {
      code: "BD",
      regex: /^(880)?\d{10}$/,
      name: "Bangladesh",
      prefix: ["880"],
    },
    { code: "BE", regex: /^(32)?\d{9}$/, name: "Belgium", prefix: ["32"] },
    {
      code: "BF",
      regex: /^(226)?\d{8}$/,
      name: "Burkina Faso",
      prefix: ["226"],
    },
    { code: "BG", regex: /^(359)?\d{9}$/, name: "Bulgaria", prefix: ["359"] },
    { code: "BH", regex: /^(973)?\d{8}$/, name: "Bahrain", prefix: ["973"] },
    { code: "BI", regex: /^(257)?\d{7,8}$/, name: "Burundi", prefix: ["257"] },
    { code: "BJ", regex: /^(229)?\d{8}$/, name: "Benin", prefix: ["229"] },
    {
      code: "BL",
      regex: /^(590)?\d{9}$/,
      name: "Saint Barthélemy",
      prefix: ["590"],
    },
    { code: "BM", regex: /^(1441)?\d{7}$/, name: "Bermuda", prefix: ["1441"] },
    {
      code: "BN",
      regex: /^(673)?\d{7}$/,
      name: "Brunei Darussalam",
      prefix: ["673"],
    },
    {
      code: "BO",
      regex: /^(591)?\d{7,8}$/,

      name: "Bolivia Plurinational State of",
      prefix: ["591"],
    },
    {
      code: "BQ",
      regex: /^(599)?\d{7}$/,
      name: "Bonaire Sint Eustatius and Saba",
      prefix: ["599"],
    },
    { code: "BR", regex: /^(55)?\d{10,11}$/, name: "Brazil", prefix: ["55"] },
    { code: "BS", regex: /^(1242)?\d{7}$/, name: "Bahamas", prefix: ["1242"] },
    { code: "BT", regex: /^(975)?\d{7,8}$/, name: "Bhutan", prefix: ["975"] },
    {
      code: "BV",
      regex: /^(47)?\d{8}$/,
      name: "Bouvet Island",
      prefix: ["47"],
    },
    { code: "BW", regex: /^(267)?\d{7,8}$/, name: "Botswana", prefix: ["267"] },
    { code: "BY", regex: /^(375)?\d{9}$/, name: "Belarus", prefix: ["375"] },
    { code: "BZ", regex: /^(501)?\d{7}$/, name: "Belize", prefix: ["501"] },
    {
      code: "CA",
      regex: /^(1)?[2-9]\d{2}[2-9]\d{2}\d{4}$/,
      name: "Canada",
      prefix: ["1"],
    },
    {
      code: "CC",
      regex: /^(61)?(89162)\d{4}$/,
      name: "Cocos (Keeling) Islands",
      prefix: ["61"],
    },
    {
      code: "CD",
      regex: /^(243)?\d{9}$/,
      name: "Congo the Democratic Republic of the",
      prefix: ["243"],
    },
    {
      code: "CF",
      regex: /^(236)?\d{8}$/,
      name: "Central African Republic",
      prefix: ["236"],
    },
    { code: "CG", regex: /^(242)?\d{9}$/, name: "Congo", prefix: ["242"] },
    { code: "CH", regex: /^(41)?\d{9}$/, name: "Switzerland", prefix: ["41"] },
    {
      code: "CI",
      regex: /^(225)?\d{8}$/,
      name: "Côte d'Ivoire",
      prefix: ["225"],
    },
    {
      code: "CK",
      regex: /^(682)?\d{5}$/,
      name: "Cook Islands",
      prefix: ["682"],
    },
    { code: "CL", regex: /^(56)?\d{9}$/, name: "Chile", prefix: ["56"] },
    { code: "CM", regex: /^(237)?\d{8}$/, name: "Cameroon", prefix: ["237"] },
    {
      code: "CN",
      regex: /^(86)?(1[3-9]\d{9})$/,
      name: "China",
      prefix: ["86"],
    },
    { code: "CO", regex: /^(57)?\d{10}$/, name: "Colombia", prefix: ["57"] },
    { code: "CR", regex: /^(506)?\d{8}$/, name: "Costa Rica", prefix: ["506"] },
    { code: "CU", regex: /^(53)?\d{8}$/, name: "Cuba", prefix: ["53"] },
    {
      code: "CV",
      regex: /^(238)?\d{7,8}$/,
      name: "Cabo Verde",
      prefix: ["238"],
    },
    { code: "CW", regex: /^(599)?\d{7}$/, name: "Curaçao", prefix: ["599"] },
    {
      code: "CX",
      regex: /^(61)?(89164)\d{4}$/,
      name: "Christmas Island",
      prefix: ["61"],
    },
    { code: "CY", regex: /^(357)?\d{8}$/, name: "Cyprus", prefix: ["357"] },
    { code: "CZ", regex: /^(420)?\d{9}$/, name: "Czechia", prefix: ["420"] },
    {
      code: "DE",
      regex: /^(49)?(1[5-7]\d{8}"1[7-9]\d{8}"16\d{9})$/,
      name: "Germany",
      prefix: ["49"],
    },
    { code: "DJ", regex: /^(253)?\d{8}$/, name: "Djibouti", prefix: ["253"] },
    { code: "DK", regex: /^(45)?\d{8}$/, name: "Denmark", prefix: ["45"] },
    { code: "DM", regex: /^(1767)?\d{7}$/, name: "Dominica", prefix: ["1767"] },
    {
      code: "DO",
      regex: /^(1809"1829"1849)?\d{7}$/,
      name: "Dominican Republic",
      prefix: [1809, 1829, 1849],
    },
    { code: "DZ", regex: /^(213)?\d{9}$/, name: "Algeria", prefix: ["213"] },
    { code: "EC", regex: /^(593)?\d{9}$/, name: "Ecuador", prefix: ["593"] },
    { code: "EE", regex: /^(372)?\d{7,8}$/, name: "Estonia", prefix: ["372"] },
    { code: "EG", regex: /^(20)?\d{10}$/, name: "Egypt", prefix: ["20"] },
    {
      code: "EH",
      regex: /^(212)?\d{9}$/,
      name: "Western Sahara",
      prefix: ["212"],
    },
    { code: "ER", regex: /^(291)?\d{7}$/, name: "Eritrea", prefix: ["291"] },
    { code: "ES", regex: /^(34)?\d{9}$/, name: "Spain", prefix: ["34"] },
    { code: "ET", regex: /^(251)?\d{9}$/, name: "Ethiopia", prefix: ["251"] },
    { code: "FI", regex: /^(358)?\d{9}$/, name: "Finland", prefix: ["358"] },
    { code: "FJ", regex: /^(679)?\d{7}$/, name: "Fiji", prefix: ["679"] },
    {
      code: "FK",
      regex: /^(500)?\d{5}$/,
      name: "Falkland Islands (Malvinas)",
      prefix: ["500"],
    },
    {
      code: "FM",
      regex: /^(691)?\d{7}$/,

      name: "Micronesia Federated States of",
      prefix: ["691"],
    },
    {
      code: "FO",
      regex: /^(298)?\d{6}$/,
      name: "Faroe Islands",
      prefix: ["298"],
    },
    { code: "FR", regex: /^(33)?[67]\d{8}$/, name: "France", prefix: ["33"] },
    { code: "GA", regex: /^(241)?\d{7}$/, name: "Gabon", prefix: ["241"] },
    {
      code: "GB",
      regex: /^(44)?(7\d{9})$/,
      name: "United Kingdom",
      prefix: ["44"],
    },
    { code: "GD", regex: /^(1473)?\d{7}$/, name: "Grenada", prefix: ["1473"] },
    { code: "GE", regex: /^(995)?\d{9}$/, name: "Georgia", prefix: ["995"] },
    {
      code: "GF",
      regex: /^(594)?\d{9}$/,
      name: "French Guiana",
      prefix: ["594"],
    },
    {
      code: "GG",
      regex: /^(44)?(1481"7781"7839"7911)\d{6}$/,
      name: "Guernsey",
      prefix: ["44"],
    },
    { code: "GH", regex: /^(233)?\d{9}$/, name: "Ghana", prefix: ["233"] },
    { code: "GI", regex: /^(350)?\d{7}$/, name: "Gibraltar", prefix: ["350"] },
    { code: "GL", regex: /^(299)?\d{6}$/, name: "Greenland", prefix: ["299"] },
    { code: "GM", regex: /^(220)?\d{7}$/, name: "Gambia", prefix: ["220"] },
    { code: "GN", regex: /^(224)?\d{8}$/, name: "Guinea", prefix: ["224"] },
    { code: "GP", regex: /^(590)?\d{9}$/, name: "Guadeloupe", prefix: ["590"] },
    {
      code: "GQ",
      regex: /^(240)?\d{9}$/,
      name: "Equatorial Guinea",
      prefix: ["240"],
    },
    { code: "GR", regex: /^(30)?\d{10}$/, name: "Greece", prefix: ["30"] },
    {
      code: "GS",
      regex: /^(500)?\d{5}$/,
      name: "South Georgia and the South Sandwich Islands",
      prefix: ["500"],
    },
    { code: "GT", regex: /^(502)?\d{8}$/, name: "Guatemala", prefix: ["502"] },
    { code: "GU", regex: /^(1671)?\d{7}$/, name: "Guam", prefix: ["1671"] },
    {
      code: "GW",
      regex: /^(245)?\d{7}$/,
      name: "Guinea-Bissau",
      prefix: ["245"],
    },
    { code: "GY", regex: /^(592)?\d{7}$/, name: "Guyana", prefix: ["592"] },
    { code: "HK", regex: /^(852)?\d{8}$/, name: "Hong Kong", prefix: ["852"] },
    {
      code: "HM",
      regex: /^(672)?\d{6}$/,
      name: "Heard Island and McDonald Islands",
      prefix: ["672"],
    },
    { code: "HN", regex: /^(504)?\d{8}$/, name: "Honduras", prefix: ["504"] },
    { code: "HR", regex: /^(385)?\d{9}$/, name: "Croatia", prefix: ["385"] },
    { code: "HT", regex: /^(509)?\d{8}$/, name: "Haiti", prefix: ["509"] },
    { code: "HU", regex: /^(36)?\d{9}$/, name: "Hungary", prefix: ["36"] },
    { code: "ID", regex: /^(62)?\d{9,12}$/, name: "Indonesia", prefix: ["62"] },
    { code: "IE", regex: /^(353)?\d{7,9}$/, name: "Ireland", prefix: ["353"] },
    { code: "IL", regex: /^(972)?\d{8,9}$/, name: "Israel", prefix: ["972"] },
    {
      code: "IM",
      regex: /^(44)?(1624"74576"7524"7624"7924)\d{6}$/,
      name: "Isle of Man",
      prefix: ["44"],
    },
    { code: "IN", regex: /^(91)?[6-9]\d{9}$/, name: "India", prefix: ["91"] },
    {
      code: "IO",
      regex: /^(246)?\d{7}$/,
      name: "British Indian Ocean Territory",
      prefix: ["246"],
    },
    { code: "IQ", regex: /^(964)?\d{10}$/, name: "Iraq", prefix: ["964"] },
    {
      code: "IR",
      regex: /^(98)?\d{10}$/,
      name: " Iran - Islamic Republic of",
      prefix: ["98"],
    },
    { code: "IS", regex: /^(354)?\d{7}$/, name: "Iceland", prefix: ["354"] },
    { code: "IT", regex: /^(39)?\d{9,10}$/, name: "Italy", prefix: ["39"] },
    {
      code: "JE",
      regex: /^(44)?(1534"7700"7797"7829"7937)\d{6}$/,
      name: "Jersey",
      prefix: ["44"],
    },
    { code: "JM", regex: /^(1876)?\d{7}$/, name: "Jamaica", prefix: ["1876"] },
    { code: "JO", regex: /^(962)?\d{9}$/, name: "Jordan", prefix: ["962"] },
    { code: "JP", regex: /^(81)?[789]0\d{8}$/, name: "Japan", prefix: ["81"] },
    { code: "KE", regex: /^(254)?\d{9}$/, name: "Kenya", prefix: ["254"] },
    { code: "KG", regex: /^(996)?\d{9}$/, name: "Kyrgyzstan", prefix: ["996"] },
    { code: "KH", regex: /^(855)?\d{8,9}$/, name: "Cambodia", prefix: ["855"] },
    { code: "KI", regex: /^(686)?\d{5}$/, name: "Kiribati", prefix: ["686"] },
    { code: "KM", regex: /^(269)?\d{7}$/, name: "Comoros", prefix: ["269"] },
    {
      code: "KN",
      regex: /^(1869)?\d{7}$/,
      name: "Saint Kitts and Nevis",
      prefix: ["1869"],
    },
    {
      code: "KP",
      regex: /^(850)?\d{9}$/,
      name: "Korea Democratic People's Republic of",
      prefix: ["850"],
    },
    {
      code: "KR",
      regex: /^(82)?(10)\d{8}$/,
      name: "Korea Republic of",
      prefix: ["82"],
    },
    { code: "KW", regex: /^(965)?\d{8}$/, name: "Kuwait", prefix: ["965"] },
    {
      code: "KY",
      regex: /^(1345)?\d{7}$/,
      name: "Cayman Islands",
      prefix: ["1345"],
    },
    { code: "KZ", regex: /^(7)?[67]\d{9}$/, name: "Kazakhstan", prefix: ["7"] },
    {
      code: "LA",
      regex: /^(856)?\d{9}$/,
      name: "Lao People's Democratic Republic",
      prefix: ["856"],
    },
    { code: "LB", regex: /^(961)?\d{7,8}$/, name: "Lebanon", prefix: ["961"] },
    {
      code: "LC",
      regex: /^(1758)?\d{7}$/,
      name: "Saint Lucia",
      prefix: ["1758"],
    },
    {
      code: "LI",
      regex: /^(423)?\d{7}$/,
      name: "Liechtenstein",
      prefix: ["423"],
    },
    { code: "LK", regex: /^(94)?\d{9}$/, name: "Sri Lanka", prefix: ["94"] },
    { code: "LR", regex: /^(231)?\d{7,8}$/, name: "Liberia", prefix: ["231"] },
    { code: "LS", regex: /^(266)?\d{8}$/, name: "Lesotho", prefix: ["266"] },
    { code: "LT", regex: /^(370)?\d{8}$/, name: "Lithuania", prefix: ["370"] },
    {
      code: "LU",
      regex: /^(352)?\d{6,9}$/,
      name: "Luxembourg",
      prefix: ["352"],
    },
    { code: "LV", regex: /^(371)?\d{8}$/, name: "Latvia", prefix: ["371"] },
    { code: "LY", regex: /^(218)?\d{9}$/, name: "Libya", prefix: ["218"] },
    { code: "MA", regex: /^(212)?\d{9}$/, name: "Morocco", prefix: ["212"] },
    { code: "MC", regex: /^(377)?\d{8,9}$/, name: "Monaco", prefix: ["377"] },
    { code: "MD", regex: /^(373)?\d{8}$/, name: "Moldova", prefix: ["373"] },
    { code: "ME", regex: /^(382)?\d{8}$/, name: "Montenegro", prefix: ["382"] },
    {
      code: "MF",
      regex: /^(590)?\d{9}$/,
      name: "Saint Martin (French part)",
      prefix: ["590"],
    },
    { code: "MG", regex: /^(261)?\d{9}$/, name: "Madagascar", prefix: ["261"] },
    {
      code: "MH",
      regex: /^(692)?\d{7}$/,
      name: "Marshall Islands",
      prefix: ["692"],
    },
    {
      code: "MK",
      regex: /^(389)?\d{8}$/,
      name: "North Macedonia",
      prefix: ["389"],
    },
    { code: "ML", regex: /^(223)?\d{8}$/, name: "Mali", prefix: ["223"] },
    { code: "MM", regex: /^(95)?\d{7,9}$/, name: "Myanmar", prefix: ["95"] },
    { code: "MN", regex: /^(976)?\d{8}$/, name: "Mongolia", prefix: ["976"] },
    { code: "MO", regex: /^(853)?\d{8}$/, name: "Macao", prefix: ["853"] },
    {
      code: "MP",
      regex: /^(1670)?\d{7}$/,
      name: "Northern Mariana Islands",
      prefix: ["1670"],
    },
    { code: "MQ", regex: /^(596)?\d{9}$/, name: "Martinique", prefix: ["596"] },
    { code: "MR", regex: /^(222)?\d{8}$/, name: "Mauritania", prefix: ["222"] },
    {
      code: "MS",
      regex: /^(1664)?\d{7}$/,
      name: "Montserrat",
      prefix: ["1664"],
    },
    { code: "MT", regex: /^(356)?\d{8}$/, name: "Malta", prefix: ["356"] },
    {
      code: "MU",
      regex: /^(230)?\d{7,8}$/,
      name: "Mauritius",
      prefix: ["230"],
    },
    { code: "MV", regex: /^(960)?\d{7}$/, name: "Maldives", prefix: ["960"] },
    { code: "MW", regex: /^(265)?\d{8,9}$/, name: "Malawi", prefix: ["265"] },
    { code: "MX", regex: /^(52)?\d{10}$/, name: "Mexico", prefix: ["52"] },
    { code: "MY", regex: /^(60)?\d{9,10}$/, name: "Malaysia", prefix: ["60"] },
    { code: "MZ", regex: /^(258)?\d{8}$/, name: "Mozambique", prefix: ["258"] },
    { code: "NA", regex: /^(264)?\d{9}$/, name: "Namibia", prefix: ["264"] },
    {
      code: "NC",
      regex: /^(687)?\d{6}$/,
      name: "New Caledonia",
      prefix: ["687"],
    },
    { code: "NE", regex: /^(227)?\d{8}$/, name: "Niger", prefix: ["227"] },
    {
      code: "NF",
      regex: /^(672)?\d{5}$/,
      name: "Norfolk Island",
      prefix: ["672"],
    },
    {
      code: "NG",
      regex: /^(234)?\d{10,11}$/,
      name: "Nigeria",
      prefix: ["234"],
    },
    { code: "NI", regex: /^(505)?\d{8}$/, name: "Nicaragua", prefix: ["505"] },
    {
      code: "NL",
      regex: /^(31)?(6)\d{8}$/,
      name: "Netherlands",
      prefix: ["31"],
    },
    { code: "NO", regex: /^(47)?\d{8}$/, name: "Norway", prefix: ["47"] },
    { code: "NP", regex: /^(977)?\d{10}$/, name: "Nepal", prefix: ["977"] },
    { code: "NR", regex: /^(674)?\d{7}$/, name: "Nauru", prefix: ["674"] },
    { code: "NU", regex: /^(683)?\d{4}$/, name: "Niue", prefix: ["683"] },
    {
      code: "NZ",
      regex: /^(64)?\d{7,10}$/,
      name: "New Zealand",
      prefix: ["64"],
    },
    { code: "OM", regex: /^(968)?\d{8}$/, name: "Oman", prefix: ["968"] },
    { code: "PA", regex: /^(507)?\d{8}$/, name: "Panama", prefix: ["507"] },
    { code: "PE", regex: /^(51)?\d{9}$/, name: "Peru", prefix: ["51"] },
    {
      code: "PF",
      regex: /^(689)?\d{8}$/,
      name: "French Polynesia",
      prefix: ["689"],
    },
    {
      code: "PG",
      regex: /^(675)?\d{7,8}$/,
      name: "Papua New Guinea",
      prefix: ["675"],
    },
    {
      code: "PH",
      regex: /^(63)?\d{10,11}$/,
      name: "Philippines",
      prefix: ["63"],
    },
    { code: "PK", regex: /^(92)?\d{10}$/, name: "Pakistan", prefix: ["92"] },
    { code: "PL", regex: /^(48)?\d{9}$/, name: "Poland", prefix: ["48"] },
    {
      code: "PM",
      regex: /^(508)?\d{6}$/,
      name: "Saint Pierre and Miquelon",
      prefix: ["508"],
    },
    { code: "PN", regex: /^(64)?\d{8}$/, name: "Pitcairn", prefix: ["64"] },
    {
      code: "PR",
      regex: /^(1787"1939)?\d{7}$/,
      name: "Puerto Rico",
      prefix: ["1787", "1939"],
    },
    { code: "PS", regex: /^(970)?\d{9}$/, name: "Palestin", prefix: ["970"] },
    { code: "PT", regex: /^(351)?\d{9}$/, name: "Portugal", prefix: ["351"] },
    { code: "PW", regex: /^(680)?\d{7}$/, name: "Palau", prefix: ["680"] },
    { code: "PY", regex: /^(595)?\d{9}$/, name: "Paraguay", prefix: ["595"] },
    { code: "QA", regex: /^(974)?\d{8}$/, name: "Qatar", prefix: ["974"] },
    { code: "RE", regex: /^(262)?\d{9}$/, name: "Réunion", prefix: ["262"] },
    { code: "RO", regex: /^(40)?\d{9}$/, name: "Romania", prefix: ["40"] },
    { code: "RS", regex: /^(381)?\d{9}$/, name: "Serbia", prefix: ["381"] },
    {
      code: "RU",
      regex: /^(7"8)?\d{10}$/,
      name: "Russian Federation",
      prefix: ["7", "8"],
    },
    { code: "RW", regex: /^(250)?\d{7,9}$/, name: "Rwanda", prefix: ["250"] },
    {
      code: "SA",
      regex: /^(966)?\d{9}$/,
      name: "Saudi Arabia",
      prefix: ["966"],
    },
    {
      code: "SB",
      regex: /^(677)?\d{5}$/,
      name: "Solomon Islands",
      prefix: ["677"],
    },
    { code: "SC", regex: /^(248)?\d{7}$/, name: "Seychelles", prefix: ["248"] },
    { code: "SD", regex: /^(249)?\d{7,8}$/, name: "Sudan", prefix: ["249"] },
    { code: "SE", regex: /^(46)?\d{9}$/, name: "Sweden", prefix: ["46"] },
    { code: "SG", regex: /^(65)?\d{8}$/, name: "Singapore", prefix: ["65"] },
    {
      code: "SH",
      regex: /^(290)?\d{4,5}$/,
      name: "Saint Helena",
      prefix: ["290"],
    },
    { code: "SI", regex: /^(386)?\d{8}$/, name: "Slovenia", prefix: ["386"] },
    {
      code: "SJ",
      regex: /^(47)?\d{8}$/,
      name: "Svalbard and Jan Mayen",
      prefix: ["47"],
    },
    { code: "SK", regex: /^(421)?\d{9}$/, name: "Slovakia", prefix: ["421"] },
    {
      code: "SL",
      regex: /^(232)?\d{7,8}$/,
      name: "Sierra Leone",
      prefix: ["232"],
    },
    {
      code: "SM",
      regex: /^(378)?\d{6,10}$/,
      name: "San Marino",
      prefix: ["378"],
    },
    { code: "SN", regex: /^(221)?\d{9}$/, name: "Senegal", prefix: ["221"] },
    { code: "SO", regex: /^(252)?\d{8,9}$/, name: "Somalia", prefix: ["252"] },
    { code: "SR", regex: /^(597)?\d{7}$/, name: "Suriname", prefix: ["597"] },
    {
      code: "SS",
      regex: /^(211)?\d{7}$/,
      name: "South Sudan",
      prefix: ["211"],
    },
    {
      code: "ST",
      regex: /^(239)?\d{7}$/,
      name: "Sao Tome and Principe",
      prefix: ["239"],
    },
    {
      code: "SV",
      regex: /^(503)?\d{8}$/,
      name: "El Salvador",
      prefix: ["503"],
    },
    {
      code: "SX",
      regex: /^(1721)?\d{7}$/,
      name: "Sint Maarten (Dutch part)",
      prefix: ["1721"],
    },
    {
      code: "SY",
      regex: /^(963)?\d{9}$/,
      name: "Syrian Arab Republic",
      prefix: ["963"],
    },
    { code: "SZ", regex: /^(268)?\d{7}$/, name: "Eswatini", prefix: ["268"] },
    {
      code: "TC",
      regex: /^(1649)?\d{7}$/,
      name: "Turks and Caicos Islands",
      prefix: ["1649"],
    },
    { code: "TD", regex: /^(235)?\d{8}$/, name: "Chad", prefix: ["235"] },
    {
      code: "TF",
      regex: /^(262)?\d{9}$/,
      name: "French Southern Territories",
      prefix: ["262"],
    },
    { code: "TG", regex: /^(228)?\d{8}$/, name: "Togo", prefix: ["228"] },
    { code: "TH", regex: /^(66)?\d{9}$/, name: "Thailand", prefix: ["66"] },
    { code: "TJ", regex: /^(992)?\d{9}$/, name: "Tajikistan", prefix: ["992"] },
    { code: "TK", regex: /^(690)?\d{4}$/, name: "Tokelau", prefix: ["690"] },
    {
      code: "TL",
      regex: /^(670)?\d{7}$/,
      name: "Timor-Leste",
      prefix: ["670"],
    },
    {
      code: "TM",
      regex: /^(993)?\d{8}$/,
      name: "Turkmenistan",
      prefix: ["993"],
    },
    { code: "TN", regex: /^(216)?\d{8}$/, name: "Tunisia", prefix: ["216"] },
    { code: "TO", regex: /^(676)?\d{5,7}$/, name: "Tonga", prefix: ["676"] },
    { code: "TR", regex: /^(90)?\d{10}$/, name: "Turkey", prefix: ["90"] },
    {
      code: "TT",
      regex: /^(1868)?\d{7}$/,
      name: "Trinidad and Tobago",
      prefix: ["1868"],
    },
    { code: "TV", regex: /^(688)?\d{5}$/, name: "Tuvalu", prefix: ["688"] },
    { code: "TW", regex: /^(886)?\d{9}$/, name: "Taiwan", prefix: ["886"] },
    { code: "TZ", regex: /^(255)?\d{9}$/, name: "Tanzania", prefix: ["255"] },
    { code: "UA", regex: /^(380)?\d{9}$/, name: "Ukraine", prefix: ["380"] },
    { code: "UG", regex: /^(256)?\d{9}$/, name: "Uganda", prefix: ["256"] },
    {
      code: "UM",
      regex: /^(1)?\d{10}$/,
      name: "United States Minor Outlying Islands",
      prefix: ["1"],
    },
    {
      code: "US",
      regex: /^(1)?[2-9]\d{2}[2-9]\d{2}\d{4}$/,
      name: "United States",
      prefix: ["1"],
    },
    { code: "UY", regex: /^(598)?\d{8,9}$/, name: "Uruguay", prefix: ["598"] },
    { code: "UZ", regex: /^(998)?\d{9}$/, name: "Uzbekistan", prefix: ["998"] },
    {
      code: "VA",
      regex: /^(379)?\d{6,10}$/,
      name: "Vatican City State",
      prefix: ["379"],
    },
    {
      code: "VC",
      regex: /^(1784)?\d{7}$/,
      name: "Saint Vincent and the Grenadines",
      prefix: ["1784"],
    },
    { code: "VE", regex: /^(58)?\d{10}$/, name: "Venezuela", prefix: ["58"] },
    {
      code: "VG",
      regex: /^(1284)?\d{7}$/,
      name: "Virgin Islands British",
      prefix: ["1284"],
    },
    {
      code: "VI",
      regex: /^(1340)?\d{7}$/,
      name: "Virgin Islands U.S.",
      prefix: ["1340"],
    },
    { code: "VN", regex: /^(84)?\d{8,9}$/, name: "Viet Nam", prefix: ["84"] },
    { code: "VU", regex: /^(678)?\d{7}$/, name: "Vanuatu", prefix: ["678"] },
    {
      code: "WF",
      regex: /^(681)?\d{6}$/,
      name: "Wallis and Futuna",
      prefix: ["681"],
    },
    { code: "WS", regex: /^(685)?\d{5,7}$/, name: "Samoa", prefix: ["685"] },
    { code: "YE", regex: /^(967)?\d{9}$/, name: "Yemen", prefix: ["967"] },
    { code: "YT", regex: /^(262)?\d{9}$/, name: "Mayotte", prefix: ["262"] },
    { code: "ZA", regex: /^(27)?\d{9}$/, name: "South Africa", prefix: ["27"] },
    { code: "ZM", regex: /^(260)?\d{9}$/, name: "Zambia", prefix: ["260"] },
    { code: "ZW", regex: /^(263)?\d{9}$/, name: "Zimbabwe", prefix: ["263"] },
  ];

  return countryRules;
}

export function getPhotoUrl(photo) {
  if (!photo) return "";
  const path = typeof photo === "string" ? photo : photo.path;
  if (!path) return "";
  // Already-absolute URLs (e.g. local blob: previews for photos staged but not yet
  // uploaded) must be returned as-is — prefixing them with BASE_URL would corrupt them.
  if (/^(blob:|data:|https?:\/\/)/i.test(path)) return path;
  const BASE_URL = process.env.REACT_APP_BASE_URL_UPLOAD || "";
  const relPath = path.replace(/^.*uploads[\\/]/, "uploads/").replace(/\\/g, "/");
  return BASE_URL + relPath;
}
